import React, { useContext } from "react";
import styles from "./styles.module.css";
import NotificationContext from "context/NotificationContext";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ONLINE_ORDER_SOURCES } from "const";

const OnlineOrderAlert = () => {
  const {
    isAlerting,
    activeAlertOrderId,
    activeAlertOrderSource,
    isRinging,
    stopRinging,
    dismissAlert,
    openOnlineOrderDetails,
  } = useContext(NotificationContext);

  if (!isAlerting || !activeAlertOrderId) {
    return null;
  }

  const handleOpenDetails = () => {
    openOnlineOrderDetails(activeAlertOrderId);
  };

  const formatSource = (source) => {
    if (source === ONLINE_ORDER_SOURCES.SWIGGY) return ONLINE_ORDER_SOURCES.SWIGGY;
    if (source === ONLINE_ORDER_SOURCES.ZOMATO) return ONLINE_ORDER_SOURCES.ZOMATO;
    return ONLINE_ORDER_SOURCES.SANOFT_CART;
  };

  return (
    <div className={styles.alertOverlay}>
      <div className={styles.alertCard}>
        {/* Pulsing bell icon */}
        <div className={`${styles.iconContainer} ${isRinging ? styles.shaking : ""}`} onClick={handleOpenDetails}>
          <div className={styles.pulseRing}></div>
          <NotificationsActiveIcon className={styles.alertIcon} />
        </div>

        {/* Info */}
        <div className={styles.infoSection} onClick={handleOpenDetails}>
          <div className={styles.badgeRow}>
            <span className={styles.badge}>NEW ONLINE ORDER</span>
            <span className={styles.sourceBadge}>{formatSource(activeAlertOrderSource)}</span>
          </div>
          <div className={styles.orderTitle}>Order #{activeAlertOrderId}</div>
          <div className={styles.orderSubtitle}>Click to review and accept order</div>
        </div>

        {/* Actions */}
        <div className={styles.actions}>
          {isRinging && (
            <button
              className={styles.muteBtn}
              onClick={(e) => {
                e.stopPropagation();
                stopRinging();
              }}
              title="Mute Alert Sound"
            >
              <VolumeOffIcon fontSize="small" />
            </button>
          )}

          <button className={styles.viewBtn} onClick={handleOpenDetails}>
            <VisibilityIcon fontSize="small" />
            <span>View</span>
          </button>

          <button
            className={styles.closeBtn}
            onClick={(e) => {
              e.stopPropagation();
              dismissAlert();
            }}
            title="Dismiss Alert"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnlineOrderAlert;
